import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';
import { RoleRequest, UserUnassignParamModel } from '../models/authorization.model';
import { Observable } from 'rxjs';
import { RoleUserFilterModel } from '../models/user.model';
import { TokenService } from './token.service';
import { UserLoginResponseModel } from '../models/authen.model';
import { Function } from '../enums/authorization';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  private searchRoleAPIUrl: string;
  private activeRoleAPIUrl: string;
  private deactiveRoleAPIUrl: string;
  private addRoleAPIUrl: string;
  private editRoleAPIUrl: string;

  private listRolesAPIUrl: string;
  private listPermisstionMatrixByRoleAPIUrl: string;
  private assignPermisstionToRoleAPIUrl: string;

  private searchRoleUsersAPIUrl: string;
  private searchUserRolesAPIUrl: string;
  private searchUsersUnassignRoleAPIUrl: string;
  private assignUsersToRoleAPIUrl:string;
  private unAssignUserToRoleAPIUrl:string;
  private assignDefaultRoleAPIUrl:string;
  private rolesNotOwnedAPIUrl:string;
  private updateUserRolesAPIUrl:string;
  private masterDataGroupsAPIUrl:string;
  private assignRegistrationRoleAPIUrl: string;
  private masterDataLHLGroupNamesAPIUrl: string;
  private masterDataLHLClassNamesByGroupNameAPIUrl: string;
  userLoggedIn: UserLoginResponseModel;

  constructor(private httpClient: HttpClient,
    private tokenService: TokenService,
    private router: Router
  ) { }

 
  public getGroups(clb:string): Observable<any>{
    this.masterDataGroupsAPIUrl = `${environment.dangkykhoatu_api}${environment.masterDataGroups}`;
    const params = { clb: clb };
    return this.httpClient.get(this.masterDataGroupsAPIUrl, { params });
  }

  public getLHLGroupNames(): Observable<any>{
    this.masterDataLHLGroupNamesAPIUrl = `${environment.dangkykhoatu_api}${environment.masterDataLHLGroupNames}`;
    return this.httpClient.get(this.masterDataLHLGroupNamesAPIUrl, {  });
  }

  public getLHLClassNamesByGroupName(groupName:string): Observable<any>{
    this.masterDataLHLClassNamesByGroupNameAPIUrl = `${environment.dangkykhoatu_api}${environment.masterDataLHLClassNamesByGroupName}`;
    const params = { groupName: groupName };
    return this.httpClient.get(this.masterDataLHLClassNamesByGroupNameAPIUrl, { params });
  }
  //for check permission
  public isAuthorizationByPerm(functionName: string, permissionName?: string): boolean {  
    if(this.tokenService.isAuthentication){      
       this.userLoggedIn = JSON.parse(this.tokenService.getUserPermissions());
       if(!this.userLoggedIn || !this.userLoggedIn.functionPermissions || !this.userLoggedIn.functionPermissions.length){
            this.router.navigate(['/401']);
       }
      //  return true;  // Tạm để ở đây để chưa chạy phần check quyền  
       for (let func of this.userLoggedIn.functionPermissions) {    
            const isMatch =
              func.function.functionName === functionName || 
              func.function.functionParent === functionName;

            if (isMatch) {
              if (!permissionName) return true;

              return func.permissions?.some(
                (perm) => perm.permissionName === permissionName
              );
            }
       }   
    }
    return false;
  }
}
